import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RolesManagerUiState {
  // UI-only state
  page: number;
  perPage: number;
  filters: Record<string, any> | undefined;
  tournamentId?: number;
}

const initialState: RolesManagerUiState = {
  page: 1,
  perPage: 8,
  filters: undefined,
};

export const rolesManagerSlice = createSlice({
  name: 'rolesManager',
  initialState,
  reducers: {
    setTournamentId(state, action: PayloadAction<{ tournamentId: number }>) {
      state.tournamentId = action.payload.tournamentId;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setPerPage(state, action: PayloadAction<number>) {
      state.perPage = action.payload;
    },
    setFilters(state, action: PayloadAction<Record<string, any> | undefined>) {
      state.filters = action.payload;
    },
    resetUi(state, action: PayloadAction<{ tournamentId?: number } | undefined>) {
      state.page = 1;
      state.perPage = 8;
      state.filters = undefined;
      state.tournamentId = action?.payload?.tournamentId ?? state.tournamentId;
    },
  },
});

export const { resetUi, setTournamentId, setPage, setPerPage, setFilters } = rolesManagerSlice.actions;

export default rolesManagerSlice.reducer;
